// src/lib/liveSocket.js
import { io } from "socket.io-client";

// .env ichida REACT_APP_BACKEND_URL bo'lsa, shuni oladi
const LIVE_URL =
  process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";

export const liveSocket = io(`${LIVE_URL}/live`, {
  autoConnect: false,
  withCredentials: true,
});
